var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAguardando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 58,
    viewBox: "0 0 67 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 12.18L56.4323 51.8947H10.5677L33.5 12.18ZM33.5 0L0 58H67L33.5 0ZM36.5455 42.7368H30.4545V48.8421H36.5455V42.7368ZM36.5455 24.4211H30.4545V36.6316H36.5455V24.4211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAguardando);
export default __webpack_public_path__ + "static/media/aguardando.d269f3bab7b1d3ecc19ceabdd6e941e4.svg";
export { ForwardRef as ReactComponent };